/**
 * Assert if only in DEV or DEV_API if `value` is `boolean`
 */

export function assertBoolean(value: unknown): asserts value is boolean {
  if (__DEV__ || __ANYDO_ENV_DEV__) {
    if (typeof value !== "boolean") {
      throw new TypeError("assertBoolean(): value isn't boolean");
    }
  }
}

export function assertString(value: unknown): asserts value is string {
  if (__DEV__ || __ANYDO_ENV_DEV__) {
    if (typeof value !== "string") {
      throw new TypeError("assertString(): value isn't string");
    }
  }
}

export function assertNullableString(value: unknown): asserts value is string | null | undefined {
  if (__DEV__ || __ANYDO_ENV_DEV__) {
    if (!(value == null || typeof value === "string")) {
      throw new TypeError("assertNullableString(): value isn't string or null or undefined");
    }
  }
}

export function assertNumber(value: unknown): asserts value is number {
  if (__DEV__ || __ANYDO_ENV_DEV__) {
    if (typeof value !== "number") {
      throw new TypeError("assertNumber(): value isn't number");
    }
  }
}

export function assertNullableNumber(value: unknown): asserts value is number | null | undefined {
  if (__DEV__ || __ANYDO_ENV_DEV__) {
    if (!(value == null || typeof value === "number")) {
      throw new TypeError("assertNullableNumber(): value isn't number or null or undefined");
    }
  }
}

export function assertNonNullable<T>(value: T, message?: string): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new TypeError(message ?? "assertNonNullable(): value is undefined or null");
  }
}

export class UnreachableCaseError extends Error {
  constructor(val: never) {
    super(`Unreachable case: ${JSON.stringify(val)}`);
  }
}
